import React from 'react';
import { Link } from 'react-router-dom';
import './Sitemap.css';
import Gettouch from '../../components/getTouch/Gettouch';
import useMetaTags from '../../hooks/useMetaTags';

const Sitemap = () => {
  useMetaTags();

  return (
    <div className="Sitemap-Main-Container">
      <div className="Sitemap-Sub-Container">
        {/* Breadcrumb */}
        <nav className="Sitemap-Breadcrumbs" aria-label="breadcrumb">
          <Link to="/">Home</Link>
          <span className="Sitemap-Breadcrumb-Separator">&gt;</span>
          <span className="Sitemap-Breadcrumb-Current">Sitemap</span>
        </nav>

        <div className="Sitemap-Header-Section">
          <h1>WEBSITE SITEMAP</h1>
          <p>
            Explore all pages, product categories, target industries, and essential information about Chemi Salt Corporation.
          </p>
        </div>

        <div className="Sitemap-Grid-Container">
          {/* Main Pages Section */}
          <div className="Sitemap-Card">
            <div className="Sitemap-Card-Header">
              <h2>🌐 Main Navigation</h2>
            </div>
            <ul className="Sitemap-Links-List">
              <li>
                <Link to="/">Home Page</Link>
                <p>Welcome, company overview, set apart factors, and key impact numbers.</p>
              </li>
              <li>
                <Link to="/aboutus">About Us</Link>
                <p>Company history since 1980, leadership, vision, mission, and core values.</p>
              </li>
              <li>
                <Link to="/products">Our Products</Link>
                <p>Comprehensive catalog of industrial salts, minerals, and chemical raw materials.</p>
              </li>
              <li>
                <Link to="/industriesWeServe">Industries We Serve</Link>
                <p>Specialized solutions for textile, food, paint, plastic, soap, and chemical manufacturing.</p>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
                <p>Office address in Vapi, phone numbers, email inquiries, and Google Map location.</p>
              </li>
            </ul>
          </div>

          {/* Product Categories Section */}
          <div className="Sitemap-Card">
            <div className="Sitemap-Card-Header">
              <h2>🧪 Product Categories</h2>
            </div>
            <ul className="Sitemap-Links-List">
              <li>
                <Link to="/salts" className="Sitemap-Category-Title">Salts</Link>
                <div className="Sitemap-Sublinks-Grid">
                  <Link to="/salts?item=Refined Salt">Refined Salt</Link>
                  <Link to="/salts?item=Crystal Salt">Crystal Salt</Link>
                  <Link to="/salts?item=Free Flow Salt">Free Flow Salt</Link>
                  <Link to="/salts?item=Fine Salt">Fine Salt</Link>
                  <Link to="/salts?item=150 PPM Salt">150 PPM Salt</Link>
                  <Link to="/salts?item=40 Mesh Salt">40 Mesh Salt</Link>
                  <Link to="/salts?item=50 PPM Salt">50 PPM Salt</Link>
                  <Link to="/salts?item=Iodised Salt">Iodised Salt</Link>
                </div>
              </li>
              <li>
                <Link to="/minerals" className="Sitemap-Category-Title">Minerals</Link>
                <div className="Sitemap-Sublinks-Grid">
                  <Link to="/minerals?item=Talc Powder">Talc Powder</Link>
                  <Link to="/minerals?item=Dolomite">Dolomite</Link>
                  <Link to="/minerals?item=Calcite">Calcite</Link>
                  <Link to="/minerals?item=China Clay">China Clay</Link>
                  <Link to="/minerals?item=Silica">Silica</Link>
                  <Link to="/minerals?item=Quartz Powder">Quartz Powder</Link>
                  <Link to="/minerals?item=Hydrated Lime">Hydrated Lime</Link>
                  <Link to="/minerals?item=Calcium Carbonate">Calcium Carbonate</Link>
                </div>
              </li>
              <li>
                <Link to="/chemicals" className="Sitemap-Category-Title">Chemicals</Link>
                <div className="Sitemap-Sublinks-Grid">
                  <Link to="/chemicals?item=Soda Ash Light">Soda Ash Light</Link>
                  <Link to="/chemicals?item=Sulphur Black">Sulphur Black</Link>
                  <Link to="/chemicals?item=Caustic Soda">Caustic Soda</Link>
                  <Link to="/chemicals?item=PAC">PAC Powder & Liquid</Link>
                  <Link to="/chemicals?item=Sodium Sulphate">Sodium Sulphate</Link>
                  <Link to="/chemicals?item=Aluminium Sulphate">Aluminium Sulphate</Link>
                  <Link to="/chemicals?item=Bleaching Powder">Bleaching Powder</Link>
                  <Link to="/chemicals?item=Citric Acid">Citric Acid</Link>
                  <Link to="/chemicals?item=Hydrogen Peroxide">Hydrogen Peroxide</Link>
                </div>
              </li>

            </ul>
          </div>

          {/* Industries We Serve Section */}
          <div className="Sitemap-Card">
            <div className="Sitemap-Card-Header">
              <h2>🏭 Industries We Serve</h2>
            </div>
            <ul className="Sitemap-Links-List">
              <li>
                <a href="/industriesWeServe#textile">Textile Industries</a>
                <p>Soda ash, hydrogen peroxide, sodium sulphate, caustic soda, reactive dyes & salts.</p>
              </li>
              <li>
                <a href="/industriesWeServe#food">Food Industries</a>
                <p>Iodized salt, black salt, starch powder, hydrated lime, citric acid.</p>
              </li>
              <li>
                <a href="/industriesWeServe#paint">Paint Industries</a>
                <p>Talc powder, dolomite, calcite, titanium dioxide, china clay, specialty chemicals.</p>
              </li>
              <li>
                <a href="/industriesWeServe#plastic">Plastic Industries</a>
                <p>Talc powder, calcium carbonate, calcite 2/5 microns, dolomite, quartz powder.</p>
              </li>
              <li>
                <a href="/industriesWeServe#chemical">Chemical Industries</a>
                <p>Soda, caustic, sodium sulphate, HCL, nitric acid, sulphuric acid, hydrogen peroxide.</p>
              </li>
              <li>
                <a href="/industriesWeServe#soap">Soap & Detergent Industries</a>
                <p>Salts, dolomite, soda ash light, china clay, AOS liquid, SLES powder/liquid, speckles.</p>
              </li>
            </ul>
          </div>

          {/* Technical & Search Crawler Files */}
          <div className="Sitemap-Card">
            <div className="Sitemap-Card-Header">
              <h2>⚙️ Search Engine Resources</h2>
            </div>
            <ul className="Sitemap-Links-List">
              <li>
                <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">XML Sitemap (sitemap.xml)</a>
                <p>Machine-readable sitemap file for Google, Bing, and search engine crawlers.</p>
              </li>
              <li>
                <a href="/robots.txt" target="_blank" rel="noopener noreferrer">Robots Instruction File (robots.txt)</a>
                <p>Robots exclusion standard configuration file for web crawlers.</p>
              </li>
            </ul>
          </div>
        </div>

        <Gettouch />
      </div>
    </div>
  );
};

export default Sitemap;
